import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Main from './Main';
import './helpers/initFA';
import Select from 'react-select';
import { selectTargetStyles } from './helpers/utils';

Select.defaultProps = { ...Select.defaultProps, styles: selectTargetStyles };

ReactDOM.render(
  <Main>
    <App />
  </Main>,
  document.getElementById('main')
);
